var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 78,
    viewBox: "0 0 72 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3 41.2C51.8 37.2 56 29.3 56 22C56 11.6 47.5 0 36 0C24.5 0 16 11.6 16 22C16 29.3 20.2 37.2 26.7 41.2C11.3 45.3 0 59.4 0 76C0 77.1 0.9 78 2 78H70C71.1 78 72 77.1 72 76C72 59.4 60.7 45.3 45.3 41.2ZM20 22C20 11.7 28.5 4 36 4C43.5 4 52 11.7 52 22C52 32.3 43.5 40 36 40C28.5 40 20 32.3 20 22ZM4.1 74C5.1 57.3 19.1 44 36 44C52.9 44 66.9 57.3 67.9 74H4.1Z",
    fill: "#0071FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.36af90b7c4289539fd2582adc203ed3c.svg";
export { ForwardRef as ReactComponent };